import {
  ITrackingPlugin,
  TTrackingEventOptions,
  TTrackingModalViewOptions,
  TTrackingPageViewOptions
} from "../plugin/tracking/plugin";

export interface ITrackingService {
  trackPageView(options: TTrackingPageViewOptions): void;
  trackModalView(options: TTrackingModalViewOptions): void;
  trackEvent(options: TTrackingEventOptions): void;
  setProperty(options: any): void;
}

const TrackingService = ({
  trackingPlugin,
  trackingId
}: {
  trackingPlugin: ITrackingPlugin;
  trackingId: string;
}): ITrackingService => {
  trackingPlugin?.init({
    trackingId,
    options: {}
  });
  return {
    trackPageView(options) {
      trackingPlugin.trackPageView(options);
    },
    trackModalView(options) {
      trackingPlugin.trackModalView(options);
    },
    trackEvent(options) {
      trackingPlugin.trackEvent(options);
    },
    setProperty(options) {
      trackingPlugin.setProperty(options);
    }
  };
};

export { TrackingService };
